export const casesKeys = {
  all: ["cases"] as const,
  lists: () => [...casesKeys.all, "list"] as const,
  list: (filters: string) => [...casesKeys.lists(), { filters }] as const,
  details: () => [...casesKeys.all, "detail"] as const,
  detail: (case_guid: string | undefined) =>
    [...casesKeys.details(), case_guid] as const,
  caseTypes: () => [...casesKeys.all, "caseTypes"] as const,
  caseChannels: () => [...casesKeys.all, "caseChannels"] as const,
  caseStatuses: () => [...casesKeys.all, "caseStatuses"] as const,
  caseStatusChangeReasons: () =>
    [...casesKeys.all, "caseStatusChangeReasons"] as const,
}
